import React from 'react';
import PropTypes from 'prop-types';


function Footer ({ closeModal }) {
  return (
    <div className="foot_btn">
      <div className="fld_btn">
        <button className="btn" onClick={closeModal}>닫기</button>
      </div>
      <div className="info_source">
        <a className="txt_link" rel="noreferrer" href="https://www.youtube.com/t/terms" target="_blank">
          <span className="txt_info">Youtube</span> 서비스 이용약관
        </a>
        <br/>
        <a className="txt_link" rel="noreferrer" href="https://policies.google.com/privacy" target="_blank">
          <span className="txt_info">Google</span> 개인정보 처리방침
        </a>
      </div>
    </div>
  );
}

Footer.propTypes = {
  closeModal: PropTypes.func.isRequired,
};

export default Footer;
